import {AbstractControl, ValidationErrors} from '@angular/forms';

// https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
// It will be also check if domain exists (for W3C spec is correct without top level domain)
export function emailAddressValidator(control: AbstractControl): ValidationErrors | null {
    const match = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9]))+$/.test(control.value);
    return match || control.value === '' ? null : {emailAddress: true};
}
